import React from "react";

import uppink from "../../../assets/Uppink.svg";
import upgreen from "../../../assets/upgreen.svg";
import downred from "../../../assets/downred.svg";
import TransactionDetails from "./../TransactionDetails";
import { Util } from "../../../../../../helpers/util";
import { Link } from "react-router-dom";

const RecentTransaction = ({ transactions }) => {
  const { currency } = Util.getCurrency();
  return (
    <div
      style={{
        width: "92%",
      }}
    >
      <div className="recent-transact">
        <div className="">
          <div className="recentT">
            <p className="recentP">Recent Transactions</p>
            <Link to="/dashboard/transaction">
              <p className="vAll">View all</p>
            </Link>
          </div>
        </div>
        {transactions.map((item) => {
          const { isNeutral } = item;
          const isPositiveNumber = item.amount > 0;
          const icon =
            (isNeutral && uppink) || (isPositiveNumber ? upgreen : downred);
          const sign = (isNeutral && " ") || (isPositiveNumber ? "+" : "-");
          const color =
            (isNeutral && "default") ||
            (isPositiveNumber ? "#038830" : "#ee5253");

          return (
            <TransactionDetails
              icon={icon}
              title={item.description}
              date={item.dateResolved.format("MMMM DD, YYYY")}
              amount={`${sign}  ${currency}${Util.formatMoneyNumber(
                Math.abs(item.amount)
              )}`}
              status={item.status}
              style={{ color }}
              key={item.id}
            />
          );
        })}
        {/* <TransactionDetails
          icon={downred}
          title={"Wallet deposit"}
          date={"Mar 30, 2021"}
          amount={"+ $10,000.00"}
          status={"Processed"}
          style={{ color: "#ee5253" }}
        />
        <TransactionDetails
          icon={uppink}
          title={"Gold Plan Vest"}
          date={"Mar 30, 2021"}
          amount={"+ $10,000.00"}
          status={"Processed"}
          style={{ color: "#ea8e03" }}
        />{" "}
        <TransactionDetails
          icon={downred}
          title={"Wallet deposit"}
          date={"Mar 30, 2021"}
          amount={"+ $10,000.00"}
          status={"Processed"}
          style={{ color: "#ee5253" }}
        /> */}
        <hr />
      </div>
      {/* chart- transac */}
    </div>
  );
};

export default RecentTransaction;
